import { SET_BUSINESS_PLAN_TERM } from "./businessPlanConfigActionTypes";

export function setPlanTerm(termCodeName) {
  return { type: SET_BUSINESS_PLAN_TERM, payload: termCodeName };
}
